
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 1080 720"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#20603D","d":"M0 0h1080v720H0z"}}),_c('path',{attrs:{"fill":"#FAD201","d":"M0 0h1080v540H0z"}}),_c('path',{attrs:{"fill":"#00A1DE","d":"M0 0h1080v360H0z"}}),_c('g',{attrs:{"transform":"translate(886.5 188.1)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","fill":"#E5BE01","d":"M116.1 0L35.692 4.699l76.452 25.35L33.26 13.777l67.286 44.273L28.56 21.915l53.534 60.18-60.18-53.534 36.135 71.985L13.777 33.26l16.272 78.884-25.35-76.452L0 116.1-1-1z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(1 -1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"scale(-1 1)"}}),_c('circle',{attrs:{"r":"34.3","fill":"#E5BE01","stroke":"#00A1DE","stroke-width":"3.4"}})])])
          )
        }
      }
    